import * as React from 'react';
import { DatePicker, Row, Col } from 'antd';
const { RangePicker } = DatePicker;
import { FormWidgetItem } from './wrapper/FormWidgetItem';
import { IWidget } from 'common/schema/widget/Widget';
import { getWidgetInputText } from '../helper/getWidgetInputText';
import { useFormikContext } from 'formik';
import { IRequest } from 'common/schema/request/Request';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { DatePickerInput } from 'client/ui/form/input/DatePickerInput';

export interface FormWidgetInputDateIntervalViewProps {
  widget: IWidget;
}

export function FormWidgetInputDateIntervalView(
  props: FormWidgetInputDateIntervalViewProps
) {
  const { widget } = props;
  const input = widget.input!;

  const [inizio, fine] = MetadataLogic.multipleFromWidget(props.widget, [
    'inizio',
    'fine'
  ]);
  const [inizioName, fineName] = [`values.${inizio.id}`, `values.${fine.id}`];

  return (
    <FormWidgetItem names={[inizioName, fineName]} widget={props.widget}>
      <Row gutter={6}>
        <Col span={12}>
          <DatePickerInput
            type="from"
            name={inizioName}
            placeholder={input.extra?.placeholderFrom ?? 'Dal'}
            style={{ width: '100%' }}
          />
        </Col>
        <Col span={12}>
          <DatePickerInput
            type="to"
            name={fineName}
            placeholder={input.extra?.placeholderTo ?? 'Al'}
            style={{ width: '100%' }}
          />
        </Col>
      </Row>
    </FormWidgetItem>
  );
}
